import React from "react";
import { ContactButtons } from "./ContactButtons";
import { businessInfo } from "../data/mockData";
import { Phone, MessageCircle, MessageSquare } from "lucide-react";

const FinalCTA = ({ title, lines = [] }) => {
  return (
    <section className="bg-brand-navy text-white py-16 lg:py-20" data-testid="final-cta">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <h2 className="text-3xl sm:text-4xl font-black tracking-tight mb-5">
          {title}
        </h2>
        {lines.length > 0 && (
          <ul className="space-y-2 mb-8 text-slate-200">
            {lines.map((l, i) => (
              <li key={i} className="text-base sm:text-lg">{l}</li>
            ))}
          </ul>
        )}
        <div className="flex justify-center mb-6">
          <ContactButtons variant="large" />
        </div>
        <div className="flex flex-col sm:flex-row gap-2 sm:gap-6 justify-center text-sm text-slate-300">
          <span className="inline-flex items-center gap-2"><Phone className="h-4 w-4" /> {businessInfo.phone}</span>
          <span className="inline-flex items-center gap-2"><MessageCircle className="h-4 w-4 text-brand-whatsapp" /> WhatsApp Available</span>
          <span className="inline-flex items-center gap-2"><MessageSquare className="h-4 w-4" /> Text Available</span>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
